export const generalNotesQueryKeys = {
  all: ['general-notes'],
  byDecedent: (decedentId) => [...generalNotesQueryKeys.all, decedentId],
};
